<template>
    <div>
        <div class="row">
            <div v-for="caseStudy in this.caseStudies" :key="caseStudy.id" class="col-md-6 col-lg-4 mb-4">
                <div class="shadow bg-white">
                    <a :href="caseStudy.url">
                        <img :src="caseStudy.thumbnail" :alt="caseStudy.title">
                    </a>
                    <div class="p-3">
                        <h2 class="h6">
                            <a :href="caseStudy.url" class="text-dark">
                                {{ caseStudy.title }}
                            </a>
                        </h2>
                        <div class="text-muted">{{ caseStudy.application.title }}</div>
                        <a :href="caseStudy.url">{{dataTexts.button_case_study }}</a>
                    </div>
                </div>
            </div>
        </div>
        <infinite-loading
            :identifier="infiniteId"
            spinner="waveDots"
            @infinite="getResult">
            <div slot="no-more">{{dataTexts.no_more_case_studies}}</div>
            <div slot="no-results">{{ dataTexts.no_case_studies }}</div>
        </infinite-loading>
    </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
export default {
    components: {
        InfiniteLoading
    },
    props: [
        "dataTexts",
        "dataApplicationId",
    ],
    data() {
        return {
            page: 1,
            caseStudies: [],
            infiniteId: +new Date(),
        };
    },
    methods: {
        getResult($state) {
            axios
                .get("/ajax/case-studies", {
                    params: {
                        page: this.page,
                        application_id: this.dataApplicationId
                    },
                })
                .then((response) => {
                    if (response.data.data.length) {
                        this.page += 1;
                        this.caseStudies.push(...response.data.data);
                        $state.loaded();
                    } else {
                        $state.complete();
                    }
                });
        }
    }
}
</script>
